import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app-components/resouces/bg-dpc/SearchFormDentalCodes.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app-components/resouces/bg-dpc/SearchFormDentalTreatments.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app-components/resouces/CopyToClipboard.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/svg/resources/Book-Cover-1.svg");
